var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{white:_vm.octave<5},style:({ background: _vm.color }),on:{"click":function($event){return _vm.handleClick(_vm.color)}}},[_c('span',[_vm._v(_vm._s(_vm.color))])])
}
var staticRenderFns = []

export { render, staticRenderFns }